












































































































import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";
import SklSvc from "@/services/SuratKeteranganKelahiranService";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { storePerawat } from "@/store/modules/perawat";
import { userModule } from "@/store/modules/user";

@Component({
  components: {
    PersonAutoComplete,
    VCDateTimePicker
  }
})
export default class SuratKeteranganKelahiranDetail extends Vue {
  @Prop() sklData!: any;
  @Prop() register!: string | number;
  @Prop() rm!: string;
  @Prop({ default: false }) readonly!: boolean;

  skl: any = null;
  saving = false;

  masters: any = {
    jenis_kelamin: [],
    status_kelahiran: [],
    jenis_penolong: []
  };

  form: any = this.emptyForm();

  async mounted() {
    await this.loadMasters();
    if (this.sklData) {
      this.skl = this.sklData;
      this.populateForm();
    } else {
      this.form.register_id = this.register;
      this.form.pasien_rm = this.rm;
      const ibu = storePasien.identitasPasien;
      if (ibu) {
        this.form.nama_ibu = ibu.nama || "";
        this.form.alamat_ibu = ibu.alamat || "";
      }
    }
  }

  emptyForm() {
    return {
      register_id: "",
      pasien_rm: "",
      nomor: "",
      status: "final",
      nama_bayi: "",
      tanggal_lahir: "",
      jam_lahir: "",
      jenis_kelamin: null,
      tempat_lahir: "RSUD Panembahan Senopati Bantul",
      status_kelahiran: "tunggal",
      urutan_kembar: null,
      berat_lahir: null,
      panjang_lahir: null,
      nama_ibu: "",
      alamat_ibu: "",
      nama_ayah: "",
      jenis_penolong: null,
      penolong_user_id: null,
      mengetahui_user_id: null
    };
  }

  get isLocked(): boolean {
    return this.readonly;
  }

  get isDraft(): boolean {
    return !this.skl || !this.skl.id || this.skl.status === "draft";
  }

  get jenisPenolongLabel(): string {
    // Ikut profesi penolong terpilih (live); /combo/karyawan menyertakan `profesi`.
    const profesiMap: any = { Dokter: "Dokter", Bidan: "Bidan", Perawat: "Perawat" };
    if (this.form.penolong_user_id) {
      const person: any = (storePerawat.listKaryawan as any[]).find(
        (p: any) => p.id === this.form.penolong_user_id
      );
      if (person && person.profesi) {
        return profesiMap[person.profesi] || "Tim (kombinasi)";
      }
    }
    const val = this.skl && this.skl.id ? this.skl.jenis_penolong : null;
    if (val) {
      const found = (this.masters.jenis_penolong || []).find(
        (it: any) => it.value === val
      );
      return found ? found.text : val;
    }
    return userModule.user?.profesi || "-";
  }

  async loadMasters() {
    try {
      const resp = await SklSvc.masters();
      if (resp?.data?.status == "1") {
        this.masters = { ...this.masters, ...resp.data.data };
      }
    } catch {
      // handled by service
    }
  }

  populateForm() {
    if (!this.skl) return;
    this.form = { ...this.emptyForm(), ...this.skl };
    // Record lama: kembar_2/3/4_plus → opsi tunggal "kembar" (jumlah via Kembar ke).
    if ((this.form.status_kelahiran || "").startsWith("kembar")) {
      this.form.status_kelahiran = "kembar";
    }
  }

  get tglJamLahir(): Date | null {
    if (!this.form.tanggal_lahir) return null;
    return moment(`${this.form.tanggal_lahir} ${this.form.jam_lahir || "00:00"}`, "YYYY-MM-DD HH:mm").toDate();
  }

  setTglJamLahir(val: Date | null) {
    this.form.tanggal_lahir = val ? moment(val).format("YYYY-MM-DD") : "";
    this.form.jam_lahir = val ? moment(val).format("HH:mm") : "";
  }

  async simpan(status: "draft" | "final") {
    if (this.saving) return;
    this.saving = true;
    try {
      const payload: any = { ...this.form, status };
      // jenis_penolong ditentukan server dari profesi pembuat
      delete payload.jenis_penolong;
      const isNew = !this.skl || !this.skl.id;
      const resp = isNew
        ? await SklSvc.create(payload)
        : await SklSvc.update(this.skl.id, payload);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay(
          status === "draft" ? "Draft Surat Kelahiran disimpan" : "Surat Kelahiran disimpan"
        );
        this.skl = resp.data.data;
        this.populateForm();
        this.$emit("saved");
      }
    } catch {
      // handled by service
    }
    this.saving = false;
  }

  cetakPdf() {
    if (this.skl?.id) {
      SklSvc.printPdf(this.skl.id);
    }
  }
}
